import { CustomerOriginModelType } from '@teinor/erp/types/company/customer/customerOrigin'
import { FormRender } from '../../../../../../../forms/FormRenderer/types'
import useTwinTranslation from '../../../../../../../utils/hooks/useTwinTranslation'
import { ModalEditComponentProps } from '../../../../../../../baseComponents/ModalsLayouts/types'
import { LittleModalCreateEdit } from '../../../../../../../baseComponents/ModalsLayouts/ModalCreateEdit'
import { valueOrDefaultValue } from '../../../../../../../utils/globals/valueOrDefaultValue'
import { permissionCheck } from '../../../../../../../baseComponents/PermissionChecker/function'

interface ModalCECustomerOriginProps extends ModalEditComponentProps { }

const ModalCECustomerOrigin: React.FC<ModalCECustomerOriginProps> = ({ userPermissions, allRowData, ...rest }) => {
    const { t } = useTwinTranslation()
    const fields: FormRender<CustomerOriginModelType> = [
        {
            cols: 1,
            elements: [
                {
                    name: 'name',
                    label: t('name', 'Nombre'),
                    component: 'InputWithLabelMargin',
                    type: 'text',
                    required: true
                },
                {
                    name: 'id',
                    component: 'InputHidden'
                },
            ]
        },
    ]
    if (allRowData && userPermissions) {
        const parsedFields = valueOrDefaultValue(fields, userPermissions, allRowData)
        return (<LittleModalCreateEdit fields={parsedFields} url={'/api/app/customer/customerOrigin/updateCustomerOrigin'} translations={{ title: t('editCustomerOrigin', 'Editar origen de cliente'), button: t('save', 'Guardar') }} haveButtonPermissions={permissionCheck(userPermissions, 'update')} {...rest} />)
    }

    return (<LittleModalCreateEdit fields={fields} url={'/api/app/customer/customerOrigin/createCustomerOrigin'} translations={{
        title: t('createCustomerOrigin', 'Crear origen de cliente'),
        button: t('create', 'Crear')
    }} haveButtonPermissions={true} {...rest} />)
}

export default ModalCECustomerOrigin